var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RoutinePage',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isRestricted),expression:"!isRestricted"}],attrs:{"entry":_vm.entry}})
}
var staticRenderFns = []

export { render, staticRenderFns }